import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import BusinessCommercial from './pages/services/BusinessCommercial';
import GeneralLiability from './pages/services/GeneralLiability';
import WorkersComp from './pages/services/WorkersComp';
import BOP from './pages/services/BOP';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/services/business-commercial" element={<BusinessCommercial />} />
          <Route path="/services/general-liability" element={<GeneralLiability />} />
          <Route path="/services/workers-compensation" element={<WorkersComp />} />
          <Route path="/services/business-owner-policy" element={<BOP />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;